import type { DirectusUsers } from '@/models/types';

export const getUserLabel = (
  user: string | DirectusUsers | null | undefined,
  unavailable: string,
) => {
  if (!user || typeof user === 'string') {
    return unavailable;
  }

  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  return name || user.email || unavailable;
};
